/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export const enum ExportType { Client, Server }; 

    
    export interface IRecordingsExports {
        clientHref: string;
        recordingsExportsData: RecordingsExportsData[];
    }

    export class RecordingsExports implements IRecordingsExports {
        public clientHref: string;
        public recordingsExportsData: RecordingsExportsData[];
    }

    export interface IRecordingsExportsData {
        serverHref: string;
        serverIpAddress: string;
        clientRecordings: ClientRecordings[];
        recordingsExports: EmbedRecordingExports;
    }

    export class RecordingsExportsData implements IRecordingsExportsData {
        public serverHref: string;
        public serverIpAddress: string;
        public clientRecordings: ClientRecordings[];
        public recordingsExports: EmbedRecordingExports;
    }

    export interface IEmbedRecordingExports {
        clientExports: ClientExportNode[];
        cptRecordings: Object[];
        iphoneUploads: Object[];
        live: LiveNode[];
        tissExports: TissExportNode[];
        tissRecordings: TissRecordingNode[];
    }

    export class EmbedRecordingExports implements IEmbedRecordingExports {
        public clientExports: ClientExportNode[];
        public cptRecordings: Object[];
        public iphoneUploads: Object[];
        public live: LiveNode[];
        public tissExports: TissExportNode[];
        public tissRecordings: TissRecordingNode[];
    }

    export interface IClientExports {
        description: string;
        downloadPath: string;
        downloadProtocol: string;
        duration: number;
        end: number;
        exportfile: string;
        insertiondate: number;
        playPath: string;
        playProtocol: string;
        resource: string;
        sessionid: number;
        start: number;
    }

    export class ClientExports implements IClientExports {
        public description: string;
        public downloadPath: string;
        public downloadProtocol: string;
        public duration: number;
        public end: number;
        public exportfile: string;
        public insertiondate: number;
        public playPath: string;
        public playProtocol: string;
        public resource: string;
        public sessionid: number;
        public start: number;
    }
    
    export interface IClientRecordings { 
        sessionId: string;
        startDate: number;
        endDate: number;
    }

    export class ClientRecordings implements IClientRecordings {
        public sessionId: string;
        public startDate: number;
        public endDate: number;
    }

    export interface IRecordingsExportsResult { 
        resource: string;
        liveNodes: LiveNode[];
        tissRecordings: TissRecordingNode[];
    }

    export class RecordingsExportsResult implements IRecordingsExportsResult {
        public resource: string;
        public liveNodes: LiveNode[];
        public tissRecordings: TissRecordingNode[];
    }

    export interface ILiveNode {
        resource: string;
        type: string;
        playProtocol: string;
        playPath: string;
    }

    export class LiveNode implements ILiveNode {
        public resource: string;
        public type: string;
        public playProtocol: string;
        public playPath: string;
    } 

    export interface ITissRecordingNode {
        resource: string;
        start: number;
        end: number;
        duration: number;
        type: string;
        playProtocol: string;
        playPath: string;
    }

    export class TissRecordingNode implements ITissRecordingNode {
        public resource: string;
        public start: number;
        public end: number;
        public duration: number;
        public type: string;
        public playProtocol: string;
        public playPath: string;
    } 

    export interface ITissExportNode {
        size: number;
        exportfile: string;
        resource: string;
        start: number;
        end: number;
        duration: number;
        description: string;
        transcode: TissExportTranscodeNode;
        stillimage: string;
        stillimageurlpath: string;
        playProtocol: string;
        playPath: string;
        downloadProtocol: string;
        downloadPath: string;
        taskId: string;
        taskStart: string;
        equals(node: TissExportNode): boolean;
    }

    export class TissExportNode implements ITissExportNode {
        public size: number;
        public exportfile: string;
        public resource: string;
        public start: number;
        public end: number;
        public duration: number;
        public description: string;
        public transcode: TissExportTranscodeNode;
        public stillimage: string;
        public stillimageurlpath: string;
        public playProtocol: string;
        public playPath: string;
        public downloadProtocol: string;
        public downloadPath: string;
        public taskId: string;
        public taskStart: string;

        public clientHref: string;
        public serverHref: string;
        public serverIpAddress: string;

        public static addFrontData(exportNode: TissExportNode, clientHref: string,
                                   serverHref: string, serverIpAddress: string): TissExportNode {
            let newNode: TissExportNode = new TissExportNode();
            newNode.size = exportNode.size;
            newNode.exportfile = exportNode.exportfile;
            newNode.resource = exportNode.resource;
            newNode.start = exportNode.start;
            newNode.end = exportNode.end;
            newNode.duration = exportNode.duration;
            newNode.description = exportNode.description;
            newNode.transcode = exportNode.transcode;
            newNode.stillimage = exportNode.stillimage;
            newNode.stillimageurlpath = exportNode.stillimageurlpath;
            newNode.playProtocol = exportNode.playProtocol;
            newNode.playPath = exportNode.playPath;
            newNode.downloadProtocol = exportNode.downloadProtocol;
            newNode.downloadPath = exportNode.downloadPath;
            newNode.taskId = exportNode.taskId;
            newNode.taskStart = exportNode.taskStart;
            newNode.clientHref = clientHref;
            newNode.serverHref = serverHref;
            newNode.serverIpAddress = serverIpAddress;
            return newNode;
        }

        public equals(node: TissExportNode): boolean {
            return this.size === node.size &&
                   this.exportfile === node.exportfile &&
                   this.resource === node.resource &&
                   this.start === node.start &&
                   this.end === node.end &&
                   this.duration === node.duration &&
                   this.description === node.description;
        }
    } 

    export interface ICPTRecordingNode {
    }

    export class CPTRecordingNode implements ICPTRecordingNode {
    }

    export interface IClientExportNode {
        exportfile: string;
        resource: string;
        start: number;
        end: number;
        insertiondate: number;
        sessionid: string;
        description: string;
        duration: number;
        transcode: ClientExportTranscodeNode;
        playProtocol: string;
        playPath: string;
        downloadProtocol: string;
        downloadPath: string;
    }

    export class ClientExportNode implements IClientExportNode {
        public exportfile: string;
        public resource: string;
        public start: number;
        public end: number;
        public insertiondate: number;
        public sessionid: string;
        public description: string;
        public duration: number;
        public transcode: ClientExportTranscodeNode;
        public playProtocol: string;
        public playPath: string;
        public downloadProtocol: string;
        public downloadPath: string;

        public clientHref: string;
        public serverHref: string;
        public serverIpAddress: string;

        public static addFrontData(exportNode: ClientExportNode, clientHref: string,
                                   serverHref: string, serverIpAddress: string): ClientExportNode {
            let newNode: ClientExportNode = new ClientExportNode();
            newNode.exportfile = exportNode.exportfile;
            newNode.resource = exportNode.resource;
            newNode.start = exportNode.start;
            newNode.end = exportNode.end;
            newNode.insertiondate = exportNode.insertiondate;
            newNode.sessionid = exportNode.sessionid;
            newNode.duration = exportNode.duration;
            newNode.description = exportNode.description;
            newNode.transcode = exportNode.transcode;
            newNode.playProtocol = exportNode.playProtocol;
            newNode.playPath = exportNode.playPath;
            newNode.downloadProtocol = exportNode.downloadProtocol;
            newNode.downloadPath = exportNode.downloadPath;
            newNode.clientHref = clientHref;
            newNode.serverHref = serverHref;
            newNode.serverIpAddress = serverIpAddress;
            return newNode;
        }
    }

    export interface IIphoneUpload {
    }

    export class IphoneUpload implements IIphoneUpload {
    }

    export interface ITissExportTranscodeNode {
        progress: string;
        resolution: string;
        filename: string;
        status: string;
        serverexportdownloadPath: string;
    }

    export class TissExportTranscodeNode implements ITissExportTranscodeNode {
        public progress: string;
        public resolution: string;
        public filename: string;
        public status: string;
        public serverexportdownloadPath: string;
    }

    export interface IClientExportTranscodeNode {
        progress: string;
        resolution: string;
        filename: string;
        status: string;
        downloadPath: string;
    }

    export class ClientExportTranscodeNode implements IClientExportTranscodeNode {
        public progress: string;
        public resolution: string;
        public filename: string;
        public status: string;
        public downloadPath: string;
    }

    export interface IAllRecordingsExports {
        allRecordingsExports: RecordingsExports[];
    }

    export class AllRecordingsExports implements IAllRecordingsExports {
        public allRecordingsExports: RecordingsExports[];
    }

    export interface IRunningTask {
        taskType: TaskType;
        taskId: string;
        resource: string;
        status: string;
        progress: string;
        description: string;
        frameNr: string;
        totalFrames: string;
    }

    export class RunningTask implements IRunningTask {
        public taskType: TaskType;
        public taskId: string;
        public resource: string;
        public status: string;
        public progress: string;
        public description: string;
        public frameNr: string;
        public totalFrames: string;
    }

    export class TaskType {
        public static CREATE_EXPORT: string = "CREATE_EXPORT";
        public static DELETE_EXPORT: string = "DELETE_EXPORT";
        public static TRANSCODE_EXPORT: string = "TRANSCODE_EXPORT";
    }
}
